
<div class="footer-layout-sec">
    <p class="text-text">{{appName}} v{{ver}}</p>
</div>